// @flow
import React from 'react';
import {withStyles} from '@material-ui/core/styles'
import ClassNames from 'classnames';
import styles from './Button.styles';

class Button extends React.Component<Props> {

  constructor(props) {
    super(props);

    this.state = {
      wrapper: null
    };
  }

  componentDidMount() {
    // let component = this.state.component;
    // if (this.props.component && this.state.component !== this.props.component) {
    //   component = this.props.component;
    // }
    // this.setState({component});
  }

  render() {
    const classes = this.props.classes;
    const parrentClasses = this.props.className;
    if (this.state.wrapper) {
      return (
        <this.state.wrapper
          className={ClassNames(classes.root, parrentClasses)}
        >
          <button className={classes.button} onClick={this.props.onClick}>
            <span className={`icon-${this.props.icon}`} />
              {this.props.text || this.state.children || ''}
          </button>
        </this.state.wrapper>
      );
    }

    return (
      <button className={classes.button} onClick={this.props.onClick}>
        {this.props.text || this.state.children || ''}
      </button>
    );
  }
}

const Component = withStyles(styles)(Button);
export {Component as Button};
export default Component;